<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <!-- <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">History Penerimaan Q dakkdwakwdkawkkR</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center">
                    <div style="background-color: white; border-radius: 4px; position: relative; border: 0">
                        <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                            <i class="fas fa-calendar"></i>
                        </span>
                        <flat-pickr v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="w-100 overflow-auto ">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>Kode BAST</th>
                        <!-- <th>POS Asa</th> -->
                        <th>Kode Pos</th>
                        <th>Nama Pos</th>
                        <th>Jumlah</th>
                        <th>Tanggal Pengiriman</th>
                        <th>Status</th>
                        <th>Tanggal Penerimaan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="(dat, index) in data">
                        <td>{{ dat.bast_no ? dat.bast_no : '-' }}</td>
                        <td>{{ dat.kode_dealer_pos ? dat.kode_dealer_pos : '-' }}</td>
                        <td>{{ dat.pos_name ? dat.pos_name : '-' }}</td>
                        <!-- <td>{{ dat.kode_dealer_pos }} - {{ dat.pos_name || '-' }}</td> -->
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : '-' }}</td>
                        <td>{{ dat.delivery_at ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>

                        <!-- Status Start -->
                        <td v-if="dat.status == 'RECEIVED'">Received</td>
                        <td v-else>
                            <div class="qtrust-custom-select">
                                <select v-model="dat.status" @change="confirmUpdate(dat, index)">
                                    <option
                                        v-for="status in options.status"
                                        :value="status.value"
                                        :disabled="status.isDisabled"
                                    >{{ status.label }}</option>
                                </select>
                                <i class="fas fa-caret-down" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: black;"></i>
                            </div>
                        </td>
                        <!-- Status End -->

                        <td>{{ dat.received_at ? moment(dat.received_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                    </tr>
                    <tr v-else-if="data && !data.length">
                        <td colspan="6">No data</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>

        <modal
            v-if="modal.confirmation"
            box-class="col-10 col-md-6 col-lg-4"
            :box-style="{
                'background': 'white',
                'margin': '0 auto',
                'border-radius': '8px',
                'overflow': 'hidden',
                'box-shadow': '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                'padding': '8px 12px'
            }"
            @closeModal="modal.confirmation = false"
        >
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Konfirmasi Penerimaan QR</h5>
                <button class="btn" @click="modal.confirmation = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="text-center mt-5">
                <i class="fas fa-exclamation-triangle" style="color: #F36F21; font-size: 120px; margin-bottom: 40px;"></i>
                <p style="margin-bottom: 4px; font-size: 16px">Anda akan menerima <span class="font-weight-bold" style="font-size: 18px;">{{ numberWithCommas(modal.confirmationData.qty) }}</span> QR</p>
                <p style="margin-bottom: 4px; font-size: 16px">Apa anda yakin jumlahnya sudah benar?</p>
            </div>

            <div style="display:flex; align-items: center; justify-content: between; max-width: 300px; margin: 40px auto 20px auto">
                <button class="btn" style="color: #F36F21; width: 33.33%" @click="modal.confirmation = false">
                    Batal
                </button>
                <button class="btn" style="background: #F36F21; color:white ; width: 66.66%" @click="modal.returnConfirmation = true; modal.confirmation = false;">
                    Ya, Proses
                </button>
            </div>
        </modal>

        <modal
            v-if="modal.returnConfirmation"
            box-class="col-11 col-md-8 col-lg-6"
            :box-style="{
                'background': 'white',
                'margin': '0 auto',
                'border-radius': '8px',
                'overflow': 'hidden',
                'box-shadow': '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                'padding': '0'
            }"
            @closeModal="modal.returnConfirmation = false"
        >
            <return-confirm-modal
                :data="modal.confirmationData"
                @closeModal="modal.returnConfirmation = false"
                @refreshData="config.page = 1; fetchPaginated()"
            ></return-confirm-modal>
        </modal>
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    import modal from '@/components/modal.vue';
    import returnConfirmModal from './ReturnConfirmModal.vue';

    export default {
        props: {
            search: {
                type: String,
                default: '',
            },
            startDate: {
                type: String,
                default: '',
            },
            endDate: {
                type: String,
                default: '',
            },
        },
        components: {
            modal,
            returnConfirmModal,
        },
        data () {
            let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
            let end = moment().format("YYYY-MM-DD");
            return {
                moment: moment,
                dateRangeConfig: {
                    mode: "range",
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altInputClass: "flatpickr-alt",
                },
                data: null,
                options: {
                    status: [
                        {label: 'In-Transit', value: 'INTRANSIT', isDisabled: true},
                        {label: 'Received', value: 'RECEIVED'},
                    ]
                },
                modal: {
                    confirmation: false,
                    confirmationData: null,
                    returnConfirmation: false,
                },
                selected: {
                    date: `${start} to ${end}`,
                },
                filter: {
                    start_date: this.startDate, 
                    end_date: this.endDate,  
                    search: '',
                },
                config: {
                    page: 1,
                    limit: 10,
                    lastPage: 0,
                    total: 0,
                },
            }
        },
        mounted () {
            this.fetchPaginated();
        },
        watch: {
            'selected.date'() {
                let dates = this.selected.date.split(' to ');
                this.setDateFilter(dates, this);
            },
            search (value) {
                this.filter.search = value ? value.trim() : '';
            },
            startDate (value) {      
                this.filter.start_date = value;
            },
            endDate (value) {      
                this.filter.end_date = value;
            },
            filter: {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                },
            },
            'config.page': {
                deep: true,
                handler: 'fetchPaginated'
            }
        },
        methods: {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            setDateFilter: debounce((dates, vm) => {
                vm.filter.start_date = dates[0];
                vm.filter.end_date = dates[1] ? dates[1] : dates[0];
            }, 2000),
            confirmUpdate(dat, index) {
                this.data[index].status = 'INTRANSIT';

                this.modal.confirmationData = dat;
                this.modal.confirmation = true;
            },
            fetchPaginated () {
                let filter = JSON.parse(JSON.stringify(this.filter));

                this.$http.get(`/api/qrs/return`, {params: {...filter, status: 'RECEIVED', page: this.config.page, limit: this.config.limit}})
                .then(res => {
                    this.data = res.data.data;
                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err) => console.log(err));
            },
        }
    }
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }
</style>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-custom-select {
        border:1px solid #E8E8E8;
        min-width: 100px;
        display: inline-block;
        border-radius: 4px;
        position: relative;
    }
    .qtrust-custom-select select {
        width: 100%;
        height: 100%;
        padding: 2px 5px;
    }
</style>